import { initialFormValues } from '../../../schema';
import type { FormMode } from '@/types/form';

type DiscountAllocationMode = 'quantity' | 'value';

interface NormalizedFormValuesOptions {
  data: BanHangSearchParams;
  formMode: FormMode;
  initialData?: BanHangSearchParams;
  transactionOptions?: Array<{ value?: string }>;
}

export const normalizedFormValues = ({
  data,
  formMode,
  initialData,
  transactionOptions = []
}: NormalizedFormValuesOptions) => {
  const transactionCode =
    formMode === 'add'
      ? transactionOptions[0]?.value || initialFormValues.ma_gd || 'HD'
      : initialData?.ma_gd ||
        initialData?.ma_gd_data?.uuid ||
        transactionOptions[0]?.value ||
        initialFormValues.ma_gd ||
        'HD';

  return {
    ...initialFormValues,
    ...data,
    ma_gd: data.ma_gd || transactionCode
  };
};

export const documentSelectionRows = ({
  currentRows,
  process,
  selectedRows
}: {
  currentRows: BanHangRecord[];
  process?: string;
  selectedRows: BanHangRecord[];
}) => {
  const rows = selectedRows.map((row, index) => ({
    ...row,
    line: index + 1,
    so_luong: row.sl_cl,
    sl_cl: row.sl_cl,
    tien_nt2: row.sl_cl * row.gia_nt2,
    tk_dt_data: row.ma_vt_data?.tk_dt_data,
    tk_gv_data: row.ma_vt_data?.tk_gv_data,
    tk_vt_data: row.ma_vt_data?.tk_khcp_data,
    tk_ck_data: row.ma_vt_data?.tk_ck_data,
    tk_km_data: row.ma_vt_data?.tk_km_data,
    tk_thue_co_data: row.ma_thue_data?.tk_thue_dau_ra_data,
    id_dh: row.don_hang_data,
    line_dh: {
      uuid: row.uuid,
      line: row.line
    }
  })) as BanHangRecord[];

  return process === '1' ? [...currentRows, ...rows] : rows;
};

const roundedAmount = (value: number) => Math.round(value * 10) / 10;

export const discountAllocationRows = (
  rows: BanHangRecord[],
  pool: number,
  mode: DiscountAllocationMode
): BanHangRecord[] => {
  const denominator = rows.reduce(
    (sum, row) => sum + (mode === 'quantity' ? Number(row.so_luong) || 0 : Number(row.tien_nt2) || 0),
    0
  );

  if (!rows.length || denominator === 0) return rows;

  return rows.map(row => {
    const amount = Number(row.tien_nt2) || 0;
    const base = mode === 'quantity' ? Number(row.so_luong) || 0 : amount;
    const discount = roundedAmount(((Number(pool) || 0) / denominator) * base);
    const amountAfterDiscount = Math.max(0, roundedAmount(amount - discount));
    const taxRate = Number(row.ma_thue_data?.thue_suat) || 0;

    return {
      ...row,
      ck_nt: discount,
      thue_nt: Math.max(0, roundedAmount((amountAfterDiscount * taxRate) / 100))
    };
  });
};
